import z from 'zod';
import {studyContentSchema} from './studyContentSchema';
import {studyStatusSchema} from './StudyStatus';

/** Document shape as stored in DB (id = topic from document id when reading). */
export const studyDbSchema = z.object({
  /** deprecated - use studyContent instead */
  content: z.string().optional(),
  /** status of the study */
  status: studyStatusSchema.optional(),
  /** array of study content */
  studyContent: z.array(studyContentSchema).optional(),
});

export type StudyDb = z.infer<typeof studyDbSchema>;
